import { useAsyncSection, type AsyncSectionState } from '../../hooks/useAsyncSection';
import { fetchWesRefreshStatus, type WesApiRefreshStatus } from './wesPalletStagingApi';

// One request when the report opens; a failure only affects the refresh text in the header.
export function useWesRefreshStatus(): AsyncSectionState<WesApiRefreshStatus> {
  return useAsyncSection(() => fetchWesRefreshStatus(), [], { toFriendlyError: () => 'Refresh time unavailable' });
}
